const translations = {
  ACTIVATION_LABEL_PASSWORD: 'Provide a password',
  ACTIVATION_LABEL_PASSWORD_CONFIRMATION: 'Repeat your password',
  ACTIVATION_SUCCESS: 'Great, your account has been activated.',
  ACTIVATION_TITLE: 'Account Activation',
  ACTIVATION_USER_GREETING: 'Hi',
  ACTIVATION_DESCRIPTION: 'complete your account activation by choosing a password. The password must be at least 8 characters long and must contain at least one uppercase character, one digit and one special character.',
  ADD_MASTER_USER: 'Add Master account',
  ADD_EDITOR_USER: 'Add Editor account',
  ADD_BASE_USER: 'Add Base account',
  ADD_DIRECTOR_USER: 'Add Director account',
  ADD_BUYER_USER: 'Add Buyer account',
  ADD_COMPANY: 'Create new company',
  ADD_USER_FIRST_NAME_PLACEHOLDER: 'First name',
  ADD_USER_LAST_NAME_PLACEHOLDER: 'Last name',
  ADD_USER_EMAIL_PLACEHOLDER: 'Email',
  ADD_PRODUCT: 'Add product',
  COMPANY_TITLE: 'company',
  COMPANY_TITLE_NOT_EDITOR: 'my company',
  COMPANY_CREATION_LABEL: 'Want to add a new company profile?',
  COMPANY_CREATION_BUTTON: 'create company',
  COMPANY_NUSERS: '# Accounts',
  COMPANY_ORDERSMADE: 'Orders Made',
  COMPANY_OFFICIALDATA: 'official data',
  COMPANY_BUSINESSINFO: 'Business Information',
  COMPANY_STRUCTURE_TAB: 'accounts',
  COMPANY_DOCUMENTS_TAB: 'documents',
  COMPANY_CONTRACTS_TAB: 'contracts',
  COMPANY_NAME: 'Company name',
  COMPANY_COUNTRY: 'Country',
  COMPANY_FISCALCODE: 'Fiscal code',
  COMPANY_VAT: 'VAT number',
  COMPANY_REA: 'REA number',
  COMPANY_CCIAA: 'CCIAA number',
  COMPANY_DUNS: 'Duns Number',
  COMPANY_REGISTRATION_NUMBER: 'Registration Number',
  COMPANY_CLIENTCODE: 'Client code',
  COMPANY_LEGALENTITY: 'Legal Entity',
  COMPANY_CEASED: 'The company has ceased and can not be selected',
  COMPANY_DIFFERENT_LEGAL_HEAD_OFFICE: 'Legal head office is in province of {{province}} and it cannot be selected.',
  COMPANY_QUESTIONNAIRE: 'Questionnaires',
  COMPANY_STRUCTURE_EMPTY: 'No MASTER accounts available.',
  ERROR_FIELD_MANDATORY: 'Mandatory fields',
  GENERIC_AT_DATE: 'at',
  GENERIC_AT_TIME: 'at',
  GENERIC_AND: 'and',
  GENERIC_ON_DATE: 'on',
  GENERIC_ANY: 'Any',
  GENERIC_ACTIVE: 'Active',
  GENERIC_ASSIGN_USER: 'assign',
  GENERIC_NOT_ACTIVE: 'Not Active',
  GENERIC_BASE: 'Base',
  GENERIC_BUYER: 'Buyer',
  GENERIC_COMPANY: 'company',
  GENERIC_COMPANY_NAME: 'denomination',
  GENERIC_CONFIRM: 'confirm',
  GENERIC_CONFIRM_TITLE: 'Are you sure?',
  GENERIC_CUSTOMER: 'Customer',
  GENERIC_DIRECTOR: 'Director',
  GENERIC_EACH: 'each',
  GENERIC_EDITOR: 'Editor',
  GENERIC_EMAIL: 'email',
  GENERIC_INSERTEDBY: 'Inserted by',
  GENERIC_INSERT: 'Insert',
  GENERIC_LOADING: 'Loading...',
  GENERIC_MASTER: 'Master',
  GENERIC_NAME: 'name',
  GENERIC_OF: 'of',
  GENERIC_FOR: 'for',
  GENERIC_PAGE: 'page',
  GENERIC_PLACEHOLDER_INSERTHERE: 'Insert here',
  GENERIC_PENDINGREQUESTS: 'pending req.',
  GENERIC_REFUSE: 'refuse',
  GENERIC_DECLINE: 'cancel',
  GENERIC_REGISTRATIONSTATUS: 'Status',
  GENERIC_RESULTS: 'results',
  GENERIC_SEARCH: 'search',
  GENERIC_SEARCH_BY: 'search by',
  GENERIC_SHOWALL: 'Show all',
  GENERIC_ALL: 'tutte',
  GENERIC_SUBMIT: 'submit',
  GENERIC_SURNAME: 'last name',
  GENERIC_TYPE: 'Type',
  GENERIC_TYPE_CLIENT: 'Client',
  GENERIC_TYPE_NONCLIENT: 'No Client',
  GENERIC_USERTYPE: 'account type',
  GENERIC_USER: 'account',
  GENERIC_UPDATE: 'update',
  GENERIC_CREATED: 'Created',
  GENERIC_UPDATED: 'Updated',
  GENERIC_CONTENT_UPDATED: 'CONTENT UPDATED',
  GENERIC_WELCOME: 'Welcome',
  GENERIC_OFFICIALDATA: 'technical data',
  GENERIC_OFFICIALDATA_EMPTY: 'There are not technical data available for this company.',
  GENERIC_QUESTIONNAIRES_EMPTY: 'There are not questionnaires for this company.',
  GENERIC_BUSINESSNAME: 'Business name',
  GENERIC_CANCEL: 'cancel',
  GENERIC_SAVE: 'save',
  GENERIC_ADD: 'Add',
  GENERIC_PARTIALSAVE: 'Save but don\'t confirm',
  GENERIC_PRINT: 'Print',
  GENERIC_FISCALCODE: 'Fiscal Code',
  GENERIC_ITALY: 'Italy',
  GENERIC_FOREIGN: 'Foreign',
  GENERIC_SELECT: 'Select',
  GENERIC_COUNTRY: 'Country',
  GENERIC_NEW: 'New',
  GENERIC_ALREADY_SET: 'Already set',
  GENERIC_UNAVAILABLE: 'Unavailable',
  GENERIC_CREDITS: 'Credits',
  GENERIC_COST: 'Cost',
  GENERIC_CREDITS_LEFT: 'Credits left',
  GENERIC_SEND: 'Send',
  GENERIC_PARTIALSEND: 'Save, but don\'t send',
  GENERIC_ADDRESS: 'Address',
  GENERIC_CITY: 'City',
  GENERIC_PHONE_NUMBER: 'Phone number',
  GENERIC_FISCAL_CODE_OR_ID_NUMBER: 'Fiscal Code or ID Number',
  REGISTRATION_NUMBER_OR_DUNS: 'Registration Number or Duns Number',
  GENERIC_CONTINUE: 'Continue',
  GENERIC_SHOWED: 'Showed',
  GENERIC_ORDER: 'order by',
  GENERIC_READ_NOTE: 'Read note',
  GENERIC_OPEN_DETAIL: 'Open detail',
  GENERIC_CLOSE_DETAIL: 'Close detail',
  GENERIC_EMPTY_VALUE: 'n/a',
  ORDER_BY_MOST_RECENT: 'Most recent',
  ORDER_BY_LESS_RECENT: 'Less recent',
  ORDER_BY_ALPHABETICAL_AZ: 'Alphabetical A-Z',
  ORDER_BY_ALPHABETICAL_ZA: 'Alphabetical Z-A',
  HEADER_COMPANIES: 'companies',
  HEADER_CONTRACTS: 'contracts',
  HEADER_NOTES: 'notes',
  HEADER_REQUESTS: 'requests',
  HEADER_ORDERS: 'place order',
  HEADER_USERS: 'Accounts',
  HEADER_ORDERS_LIST: 'Orders list',
  NAVIGATION_ITEM_ACCOUNTS: 'Accounts',
  NAVIGATION_ITEM_ACCOUNTS_CLIENTS: 'Clients',
  NAVIGATION_ITEM_ACCOUNTS_NON_CLIENTS: 'Non clients',
  NAVIGATION_ITEM_ACCOUNTS_NON_EDITORS: 'Editors',
  NAVIGATION_ITEM_COMPANIES: 'Companies',
  NAVIGATION_ITEM_COMPANY: 'My company',
  NAVIGATION_ITEM_PROFILE_LOGOUT: 'Logout',
  NAVIGATION_ITEM_PROFILE_CHANGE_PASSWORD: 'Change password',
  NAVIGATION_ITEM_ORDERS: 'Orders',
  HOME_SUBTITLE: 'Your notifications from Nando',
  LOGIN_HEADFORM: 'Insert your credentials',
  ACCOUNTS_USER_CREATION_COMPANY: 'Do you have a new client company?',
  ACCOUNTS_USER_CREATION_COMPANY2: 'Do you have a new NON client company?',
  EDITOR_USER_CREATION_LABEL: 'Do you want to create a new Editor account?',
  MASTERBASE_USER_CREATION_LABEL: 'Do you want to create a new Master or Base account?',
  MASTER_USER_CREATION_LABEL: 'Do you want to create a new Director account?',
  DIRECTOR_USER_CREATION_LABEL: 'Do you want to create a new Buyer account?',
  BUYER_USER_CREATION_LABEL: 'Do you want to create a new Base account?',
  REDIRECT_LOGIN: 'go to LOGIN',
  REQUEST_TOCONFIRM: 'Pending Requests',
  ACCOUNTS_TITLE: 'Clients accounts',
  ACCOUNTS_TITLE2: 'Non clients accounts',
  ACCOUNTS_TITLE3: 'Editor accounts',
  ACCOUNTS_TOCONFIRM: 'Account to be confirmed',
  ACCOUNTS_ASK_CONFIRM: 'Are you sure you want to approve the following account?',
  ACCOUNTS_ASK_REFUSE: 'Are you sure you want to refuse the following account?',
  ACCOUNTS_ASK_REMOVE: 'Are you sure you want to remove the following account?',
  DOCUMENT_COMPLETED: 'completed',
  DOCUMENT_REVIEW: 'review',
  DOCUMENT_INCOMPLETE: 'incomplete',
  DOCUMENTS_REQUESTED: 'requested documents',
  DOCUMENTS_ADD: 'Add technical information',
  DOCUMENTS_SOURCE_NETTUNO: 'Nettuno',
  DOCUMENTS_SOURCE_CUSTOM: 'Manual',
  DOCUMENTS_EMPTY: 'No documents available',
  BUSINESS_BUYERNAME: 'buyer name',
  BUSINESS_BUYERNAME_SEARCH: 'buyer name',
  BUSINESS_REQUESTINGCOMPANY: 'requesting company',
  BUSINESS_STATUS: 'BI status',
  BUSINESS_GENERIC_DATA: 'generic data',
  REPORT_TITLE: 'Report',
  QUICK_REPORT_TITLE: 'Quick Report',
  BUSINESS_INFORMATION_TITLE: 'Business Information',
  BUSINESS_INFORMATION_REQUESTEDBY: 'requested by',
  BUSINESS_INFORMATION_BUYORDER: 'Order date',
  BUSINESS_INFORMATION_EDITOR: 'editor',
  BUSINESS_INFORMATION_NOTES: 'Most interesting client details',
  BUSINESS_INFORMATION_LANGUAGE: 'language',
  BUSINESS_INFORMATION_ADDRESS: 'Company main address',
  BUSINESS_INFORMATION_NUMEMPLOYEES: 'Employees',
  BUSINESS_INFORMATION_FOUNDEDIN: 'Founded in',
  BUSINESS_INFORMATION_COREBUSINESS: 'Core business',
  BUSINESS_INFORMATION_ESTATE: 'Company estate presence',
  BUSINESS_INFORMATION_WAITING_TI: 'We are waiting for technical information...',
  BUSINESS_INFORMATION_TECHDOC_LINK: 'Technical information link',
  BUSINESS_INFORMATION_SAVETEXT: 'Do you want to confirm and set as completed?',
  BUSINESS_CLOSING_COMMENT: 'Final Comment',
  TECHDOC_SAVEQUESTION: 'Do you want to save as official data?',
  ORDERS_WIZARD_TITLE: 'Search Companies',
  ORDERS_WIZARD_SEARCH_LABEL: 'Search by:',
  ORDERS_WIZARD_RADIO_NAME: 'Name',
  ORDERS_WIZARD_PLACEHOLDER_PROVINCE: 'Province',
  ORDERS_WIZARD_INVESTIGATION_CODE: 'Company Code',
  ORDERS_WIZARD_INVESTIGATION_CODE_PLACEHOLDER: 'e.g. ADFD12',
  ORDERS_WIZARD_INVESTIGATION_SUBCODE: 'Company Subcode',
  ORDERS_WIZARD_INVESTIGATION_SUBCODE_PLACEHOLDER: 'e.g. ADFD12',
  ORDERS_WIZARD_FIRST_NAME_LABEL: 'Type the first name of the company representative:',
  ORDERS_WIZARD_REPRESENTATIVE_FIRST_NAME_PLACEHOLDER: 'e.g. John',
  ORDERS_WIZARD_LAST_NAME_LABEL: 'Type the last name of the company representative:',
  ORDERS_WIZARD_REPRESENTATIVE_LAST_NAME_PLACEHOLDER: 'e.g. Appleseed',
  ORDERS_WIZARD_EMAIL_LABEL: 'Type the email of the company representative:',
  ORDERS_WIZARD_REPRESENTATIVE_EMAIL_PLACEHOLDER: 'e.g. john.appleseed@email.com',
  ORDERS_WIZARD_PHONE_LABEL: 'Type the phone number of the company representative:',
  ORDERS_WIZARD_REPRESENTATIVE_PHONE_PLACEHOLDER: 'e.g. +39 345 1234567',
  ORDERS_WIZARD_BUSINESS_NAME_PLACEHOLDER: 'e.g. Appleseed Corporation',
  ORDERS_WIZARD_FISCAL_CODE_PLACEHOLDER: 'e.g. 0000000000',
  ORDERS_WIZARD_REA_NUMBER_PLACEHOLDER: 'e.g. 0000000000',
  ORDERS_WIZARD_VAT_NUMBER_PLACEHOLDER: 'e.g. 0000000000',
  ORDERS_WIZARD_REASON_LABEL: 'Notes',
  ORDERS_WIZARD_REASON_PLACEHOLDER: 'Write some notes and investingation\'s focus points...',
  ORDERS_WIZARD_ADDRESS_LABEL: 'Address of the establishment to be investigated',
  ORDERS_WIZARD_ADDRESS_PLACEHOLDER: 'Establishment address',
  ORDERS_WIZARD_FOREIGN_CITY_PLACEHOLDER: 'e.g. London',
  SEARCH_RESULTS: 'Search results',
  SEARCH_RESULTS_LEGAL_HEAD_OFFICE: 'Legal head office',
  SEARCH_RESULTS_LOCATION: 'Province',
  SEARCH_RESULTS_LEGAL_STATUS: 'Legal status',
  SEARCH_RESULTS_COREBUSINESS: 'Core business',
  SEARCH_RESULTS_ADDRESS: 'Address',
  SEARCH_RESULTS_REGISTRATION_NUMBER: 'Registration Number',
  SEARCH_RESULTS_DUNS: 'Duns Number',
  SEARCH_RESULTS_PROVINCE_REA: 'Prov./ Rea N.',
  SEARCH_RESULTS_STATUS: 'Status',
  SEARCH_RESULTS_LOADING: 'We are loading search results...',
  SEARCH_COMPANY: 'Search company',
  LOGIN_TITLE: 'Log in to Nando.',
  LOGIN_SUBTITLE: 'Enter your details below.',
  LOGIN_USERNAME_LABEL: 'Email address',
  LOGIN_PASSWORD_LABEL: 'Password',
  LOGIN_PASSWORD_PLACEHOLDER: 'Enter your password',
  LOGIN_SUBMIT: 'Log in',
  LOGIN_FORGOT_PASSWORD_CTA: 'Forgot password?',
  TABLE_GENERIC_EMPTY_LIST: 'No elements are available',
  TABLE_BI_EMPTY_LIST: 'No Business Information is available for this company.',
  RESET_PASSWORD_TITLE: 'Password reset',
  RESET_PASSWORD_SUBTITLE: 'Please enter your new password.',
  RESET_PASSWORD_CTA: 'Set new password',
  RESET_PASSWORD_SUCCESS_TITLE: 'Done!',
  RESET_PASSWORD_SUCCESS_INSTRUCTIONS: 'Now you can log in with your new password.',
  RESET_PASSWORD_REQUEST_TITLE: 'Forgot your password?',
  RESET_PASSWORD_REQUEST_SUBTITLE: 'Enter your email address below and we will help you with it.',
  RESET_PASSWORD_REQUEST_CTA: 'Request reset link',
  RESET_PASSWORD_REQUEST_SUCCESS_TITLE: 'Almost done...',
  RESET_PASSWORD_REQUEST_SUCCESS_INSTRUCTIONS: 'We\'ve sent you an email with the instructions on how to set a new password to your account.',
  RESET_PASSWORD_BACK_TO_LOGIN_CTA: 'Back to login',
  RESET_PASSWORD_VALIDATION_FAILED_TITLE: 'Something didn\'t work...',
  CHANGE_PASSWORD_TITLE: 'Change password',
  CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD: 'Current password',
  CHANGE_PASSWORD_LABEL_NEW_PASSWORD: 'New password',
  CHANGE_PASSWORD_LABEL_PASSWORD_CONFIRMATION: 'Repeat new password',
  CHANGE_PASSOWRD_CTA: 'Save password',
  CHANGE_PASSWORD_SECONDARY_CTA: 'Cancel',
  CHANGE_PASSWORD_SUCCESS: 'Password has been changed succesfully.',
  ORDERS_TITLE: 'Orders',
  ORDERS_TITLE_PENDING: 'Pending Orders',
  ORDERS_TITLE_ARCHIVED: 'Archived Orders',
  ORDERS_TITLE_EDITED: 'Reopened Orders',
  ORDERS_QUESTIONNAIRES: 'Questionnaires',
  ORDERS_EMPTY_LIST_MESSAGE: 'No orders available',
  ORDER_MAKE: 'Make order',
  QUESTIONNAIRE_CHECK_TITLE: 'check form',
  QUESTIONNAIRE_ASSESSMENT_TITLE: 'self assessment',
  STATUS_APPROVED: 'Approved',
  STATUS_REJECTED: 'Rejected',
  STATUS_REVIEWING: 'Reviewing',
  ACCOUNT_TYPE_EDITOR: 'Editor',
  ACCOUNT_TYPE_MASTER: 'Master',
  ACCOUNT_TYPE_DIRECTOR: 'Director',
  ACCOUNT_TYPE_BUYER: 'Buyer',
  ACCOUNT_TYPE_BASE: 'Base',
  TABLE_HEADER_NAME: 'Name',
  TABLE_HEADER_COMPANY: 'Company',
  TABLE_HEADER_STATUS: 'Status',
  TABLE_HEADER_ACCOUNT_TYPE: 'Account type',
  TABLE_HEADER_INSERTED_BY: 'Added by',
  TABLE_HEADER_ACTIVE: 'Active',
  TABLE_HEADER_TYPE: 'Type',
  TABLE_HEADER_ACCOUNTS_COUNT: '# Accounts',
  TABLE_HEADER_ORDERS_COUNT: '# Orders',
  TABLE_HEADER_PENDING_ORDERS_COUNT: '# Pending Orders',
  TABLE_HEADER_COUNTRY: 'Country',
  MODAL_TITLE_CREATE_ACCOUNT: 'Create new {{userType}} account',
  MODAL_TITLE_APPROVE_ACCOUNT: 'Approve account',
  MODAL_TITLE_REJECT_ACCOUNT: 'Reject account',
  CREATE_ACCOUNT_COMPANY_LABEL: 'Company',
  CREATE_ACCOUNT_COMPANY_PLACEHOLDER: 'Pick a company...',
  CREATE_ACCOUNT_FIRST_NAME_LABEL: 'First name',
  CREATE_ACCOUNT_FIRST_NAME_PLACEHOLDER: 'John',
  CREATE_ACCOUNT_LAST_NAME_LABEL: 'Last name',
  CREATE_ACCOUNT_LAST_NAME_PLACEHOLDER: 'Appleseed',
  CREATE_ACCOUNT_EMAIL_LABEL: 'Email',
  CREATE_ACCOUNT_EMAIL_PLACEHOLDER: 'john.appleseed@email.com',
  CREATE_ACCOUNT_CTA_CREATE: 'Create',
  CREATE_ACCOUNT_CTA_CANCEL: 'Cancel',
  APPROVE_ACCOUNT_CTA: 'Approve',
  REJECT_ACCOUNT_CTA: 'Reject',
  APPROVE_REJECT_ACCOUNT_CTA_CANCEL: 'Cancel',
  REJECT_ACCOUNT_REASON_LABEL: 'Reason',
  REJECT_ACCOUNT_REASON_PLACEHOLDER: '(Optional) Fill with the rejection reason...',
  ORDERS_PLACE_DESCRIPTION: 'Do you want to know more about a company?',
  ORDERS_PLACE_CTA: 'Place order',
  ORDERS_REQUEST_CTA: 'Request',
  QUESTIONNAIRE_EXPORT_FACSIMILE: 'Export fac-simile',
  QUESTIONNAIRE_SA_SEND_QUESTION: 'Do you want do definitely send a new Self Assessment version?',
  QUESTIONNAIRE_CF_SEND_QUESTION: 'Do you want do definitely send a new Check Form version?',
  TABLE_CONTRACT_EMPTY_LIST: 'No contract is available for this company.',
  TABLE_CONTRACT_VALID_FROM: 'Valid from',
  TABLE_CONTRACT_VALID_UNTIL: 'Valid until',
  TABLE_CONTRACT_NUMBER: 'Number',
  TABLE_CONTRACT_DOCUMENT: 'Document',
  TABLE_CONTRACT_CREDITS: 'Credits',
  CONTRACT_EDIT: 'Edit contract',
  CONTRACT_CREATE: 'Create contract',
  CONTRACT_NUMBER: 'Contract number',
  CONTRACT_VALID_FROM: 'Contract valid from',
  CONTRACT_VALID_UNTIL: 'Contract valid until',
  CONTRACT_DOCUMENT: 'Attach new document',
  CONTRACT_EDIT_CANCEL: 'Cancel',
  CONTRACT_CREATION_LABEL: 'Want to add a new contract?',
  CONTRACT_CREATION_BUTTON: 'create contract',
  PRICE_LIST: 'Price list',
  USE_DEFAULT_PRICE_LIST: 'Use default price list',
  QUESTIONNAIRE_SEND_QUESTION: 'Do you want to definitely send this version of {{title}}?',
  TABLE_EMPTY_REVIEWING_ACCOUNTS: 'At the moment there are not accounts to be approved.',
  GO_TO_NANDO_CTA: 'Go to Nando',
  GO_TO_FORM_CTA: 'Learn more',
  CONFIRM_DELETE_DOCUMENT_MESSAGE: 'Are you sure you want to delete the document?',
  QUESTIONNAIRE_DOCUMENTS_NOT_UPLOADED: 'No document uploaded',
  ORDER_CONTACT_PERSON_TITLE: 'Company\'s contact person',
  ORDER_CONTACT_PERSON_NAME: 'Name',
  ORDER_CONTACT_PERSON_EMAIL: 'Email address',
  ORDER_CONTACT_PERSON_PHONE: 'Phone number',
  ORDER_INVESTIGATION_TITLE: 'Investigation Codes',
  ORDER_INVESTIGATION_UPDATE: 'Update codes',
  ORDER_REASON_TITLE: 'Notes',
  QUESTIONNAIRE_REJECT: 'Reject Questionnaire',
  QUESTIONNAIRE_APPROVE: 'Approve Questionnaire',
  QUESTIONNAIRES_TOCONFIRM: 'Questionnaires to confirm',
  QUESTIONNAIRE_ITEM_INPUT_PLACEHOLDER: 'Write {{fieldName}}',
  QUESTIONNAIRE_ITEM_TEXTAREA_PLACEHOLDER: 'Write text',
  QUESTIONNAIRE_ITEM_INPUT_GENERIC_PLACEHOLDER: 'Write value',
  HOME_SHOW_PREV: 'Show previous page',
  HOME_SHOW_NEXT: 'Show next page',
  COMPLIANCE_TOOLTIP: 'The positive results below could be attributed to homonyms. Request a deepening by email',
  COMPANY_BUDGETS_CONTRACT: 'All budgets assigned to the accounts are refering to the following active contract:',
  COMPANY_BUDGETS_CONTRACT_NUMBER: 'Contract number',
  COMPANY_BUDGETS_CONTRACT_CREDITS: 'Credits',
  COMPANY_BUDGETS_CONTRACT_VALID_FROM: 'Valid from',
  COMPANY_BUDGETS_CONTRACT_VALID_UNTIL: 'Valid until',
  COMPANY_BUDGETS_CONTRACT_EDIT_CTA: 'If you want to update it, go to company\'s CONTRACTS section.',
  COMPANY_STRUCTURE_DIRECTOR_EMPTY: 'No DIRECTOR accounts available.',
  COMPANY_STRUCTURE_BASE_EMPTY: 'No BASE accounts available.',
  USERS_BASE_LIST: 'Base',
  COMPLETE_ORDER_MODAL_TITLE: 'Complete order',
  COMPLETE_ORDER_MODAL_DESCRIPTION_GENERAL: 'You are going to complete order made by {{buyerName}} about {{companyName}}.',
  COMPLETE_ORDER_MODAL_DESCRIPTION_ATTACH_MESSAGE: '{{buyerName}} will receive a mail notification. Please attach a final comment to it that will be attached to the order\'s report.',
  COMPLETE_ORDER_MODAL_MESSAGE_LABEL: 'Conclusions',
  COMPLETE_ORDER_MODAL_MESSAGE_PLACEHOLDER: 'Type the comment to be attached to the report',
  COMPLETE_ORDER_MODAL_CONFIRM_CTA: 'Confirm',
  COMPLETE_ORDER_MODAL_CANCEL_CTA: 'Cancel',
  ORDER_COMPLETE_CTA: 'Complete Order',
  REOPEN_ORDER_MODAL_DESCRIPTION_ATTACH_MESSAGE: '{{buyerName}} will receive a mail notification. If you like, you can attach a message to it.',
  REOPEN_ORDER: 'Reopen order',
  REOPEN_ORDER_MODAL_MESSAGE_LABEL: 'Message',
  REOPEN_ORDER_MODAL_DESCRIPTION_GENERAL: 'You are going to reopen order made by {{buyerName}} about {{companyName}}.',
  NO_USERS_TO_CONFIRM: 'There are no accounts to confirm',
  NO_QUESTIONNAIRES_TO_CONFIRM: 'There are no questionnaires to confirm.',
  BUSINESS_INFORMATION_EMPTY_LIST: 'No elements to show.',
  SCORE_DESCRIPTION: 'Score description',
  ORDER_RECAP: 'Order recap',
  TABLE_HEADER_QUICK_SCORE: 'Quick Report',
  TABLE_HEADER_BASE_SCORE: 'BI',
  TABLE_HEADER_NANDO_SCORE: 'Nando Rating',
  TABLE_HEADER_NANDO_PLUS_SCORE: 'Nando Rating+',
  REPUTATION: 'Reputation and Credibility',
  PRODUCT_DESCRIPTION_QUICK_REPORT: 'Quick Report',
  PRODUCT_DESCRIPTION_BASE: 'Business Information',
  PRODUCT_DESCRIPTION_TOP: 'Nando Rating',
  PRODUCT_DESCRIPTION_PREMIUM: 'Nando Rating+',
  PRODUCT_DESCRIPTION_QUALITY_SCORE: 'Quality Score',
  PRODUCT_DESCRIPTION_MATCH_SCORE: 'Match Score',
  PRODUCT_DESCRIPTION_ALERTS_CHECK: 'Alerts Check',
  PRODUCT_DESCRIPTION_COMPLIANCE: 'Compliance',
  PRODUCT_DESCRIPTION_PEP: 'Politically exposed People',
  PRODUCT_DESCRIPTION_LEGAL_EVENTS: 'Legal Events',
  ORDERS_LIST_PRODUCT_DESCRIPTION_QUICK_REPORT: 'QUICK REPORT',
  ORDERS_LIST_PRODUCT_DESCRIPTION_BASE: 'BUSINESS INFORMATION',
  ORDERS_LIST_PRODUCT_DESCRIPTION_TOP: 'NANDO RATING',
  ORDERS_LIST_PRODUCT_DESCRIPTION_PREMIUM: 'NANDO RATING+',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_QUICK_REPORT: 'Real-time Report on companies with Rating, Credit Opinion, Compliance checks, negativities verification and controls on Beneficial Owner.  Rating and Commercial Credit Line are calculated through an automatic algorithm.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_BASE: 'Analysis of a company with postponed processing and with a punctual evaluation carried out by an analyst, starting from the information present in the QUICK REPORT. Rating and Credit Opinion are validated by the analyst.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_TOP: 'Integration into the BUSINESS INFORMATION of the CHECK FORM questionnaire results, which is directly compiled by the analyzed company and which allows you to obtain further updated elements such as Certifications, Regularity in the Tax payment, possible Covid-19 impacts, etc. . This analysis assigns a specific Rating.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_PREMIUM: 'Integration of NANDORATING with the SELF ASSESSMENT questionnaire compiled to evaluate one or more company\'s factories and sites. The analysis of the results assigns a specific Rating.',
  BI_SAVE_AND_CONFIRM_CTA: 'Save and confirm',
  COMPANY_EDIT: 'Edit company',
  TABLE_HEADER_LAST_UPDATED_AT: 'Last updated at',
  BUSINESS_INFORMATION_TRUST_STATEMENT_LABEL: 'Credit Opinion',
  SCORE_LEGEND_TITLE: 'Legend',
  SCORE_LEGEND_DESCRIPTION_CRITICAL: 'Critical',
  SCORE_LEGEND_DESCRIPTION_WEAK: 'Weak',
  SCORE_LEGEND_DESCRIPTION_FAIR: 'Fair',
  SCORE_LEGEND_DESCRIPTION_GOOD: 'Good',
  SCORE_LEGEND_DESCRIPTION_EXCELLENT: 'Excellent',
  SCORE_LEGEND_BASE_DESCRIPTION_CRITICAL: 'Extremely vulnerable company, late in payments, very high debt and organizational difficulties. Presence of official negativities and/or Newly established company and in the start-up phase.',
  SCORE_LEGEND_BASE_DESCRIPTION_WEAK: 'Company currently vulnerable. The solvency of the debts assumed mainly depends on favorable economic and financial conditions. Balance sheet data with negative trend. A high but still sustainable debt emerges and/or Company that has been operating for a short time and needs consolidation. Company little known on the market.',
  SCORE_LEGEND_BASE_DESCRIPTION_FAIR: 'Company with adequate capacities to comply with the obligations assumed. However, adverse economic conditions can generate less ability to fulfill the obligations assumed. A company of modest dimensions and with generally discrete economic results. Sufficiently introduced company  in the sector of belonging.',
  SCORE_LEGEND_BASE_DESCRIPTION_GOOD: 'Company with good abilities to comply with the obligations assumed. It shows a good economic and financial balance and a good structure. The balance sheet data are satisfactory and with positive trends.',
  SCORE_LEGEND_BASE_DESCRIPTION_EXCELLENT: 'Company with excellent ability to honor the obligations assumed and with a constant growth in recent years. Consolidated structure. Solid company with optimal economic results.',
  SCORE_LEGEND_TOP_DESCRIPTION_CRITICAL: 'Company that operates in areas where there is a very high country risk. It has a number of uncontrolled production sites or in areas with very high country risk. Process Certifications absent or inadequate. Absent or non-compliant Tax Compliance Certification. Little collaboration in company profiling.',
  SCORE_LEGEND_TOP_DESCRIPTION_WEAK: 'Company that operates in areas where there is a high country risk. It has a number of uncontrolled production sites or in areas with high country risk. Process Certifications expired and not renewed. Absent or non-compliant Tax Compliance Certification. Little collaboration in company profiling.',
  SCORE_LEGEND_TOP_DESCRIPTION_FAIR: 'Company that operates in areas where there is a medium country risk. It has a number of controlled production sites and in areas with medium country risk. Process Certifications in the expiration phase or in the renewal phase. Tax Compliance Certification in expiration phase. Decent collaboration in company profiling.',
  SCORE_LEGEND_TOP_DESCRIPTION_GOOD: 'Company that operates in areas where there is a low country risk. It has a number of controlled production sites and in areas with low country risk. Few active Process Certifications. Updated Tax Compliance Certification. Good cooperation in company profiling.',
  SCORE_LEGEND_TOP_DESCRIPTION_EXCELLENT: 'Company operating in areas where there is minimal country risk. It has a number of controlled production sites and in areas with minimal country risk. Complete process Certifications. Updated Tax Compliance Certification. Excellent collaboration in company profiling.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_CRITICAL: 'Badly structured and disorganized Facility. Located in a country with a very high country risk.Absent or totally inadequate Security systems. Absent or totally inadequate Safety systems. Lack of energy continuity systems and technological infrastructures that are absent or totally inadequate.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_WEAK: 'Mediocre and poorly organized Facility. Located in a country with a high country risk. Poor security measures. Poor safety systems. Lack of energy continuity systems and inadequate technological infrastructures.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR: 'Decently organized Facility. Located in a country with medium country risk. Decent security measures. Decent safety systems. Presence of energy continuity systems and discrete technological infrastructures.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_GOOD: 'Well organized establishment. Located in a country with a low country risk. Good security measures. Good safety systems. Presence of energy continuity systems and good technological infrastructures.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_EXCELLENT: 'Facility in perfect conditions and well organized. Located in a country with minimal country risk. Excellent security measures. Excellent safety systems. Presence of energy continuity systems and cutting-edge technological infrastructures.',
  QUESTIONNAIRE_PREVIEW_SCORE_LABEL: 'Partial score computed from questionnaire\'s answers',
  QUESTIONNAIRE_FINAL_SCORE_LABEL: 'Final score',
  GENERIC_REQUIRED_FIELDS: 'Required fields',
  GENERIC_OPTIONAL_FIELDS: 'Optional fields',
  PLACING_ORDER_LOADING: 'We are processing your order. It will take only few seconds...',
  QUESTIONNAIRE_MAX_SIZE_UPLOAD: 'Max 50 MB',
  PRIVACY_POLICY_ACCEPTED: 'I read and I accept the',
  UPDATED: 'Updated at',
  COMING_SOON: 'Coming soon',
  NO_MATCHES_FOUND: 'No matches found',
  MATCHES_FOUND: 'Matches found',
  VALUES_YES: 'Yes',
  VALUES_NO: 'No',
  NO_ELEMENTS_TO_VIEW: 'There are no elements to show.',
  SET_QUESTIONNAIRE_TO_DRAFT: 'Set this Questionnaire to the DRAFT status',
  SET_QESTIONNAIRE_TO_DRAFT_MESSAGE: 'Indicate below the changes to be made to the questionnaire (mandatory).',
  SET_BUSINESSINFO_TO_DRAFT: 'Set this Business Information to the DRAFT status',
  SET_BUSINESSINFO_TO_DRAFT_MESSAGE: 'Indicate below the changes to be made to the business info (mandatory).',
  SET_TECH_DOC_TO_DRAFT: 'Set this technical data to the DRAFT status',
  GENERIC_CONTACT: 'Contact',
  GENERIC_WEBSITE: 'Website',
  GENERIC_ELECTRONIC_INVOICE: 'SDI Electronic invoice',
  GENERIC_VARIOUS: 'Various',
  ORDERS_SUMMARY: 'Orders summary',
  GENERIC_TECH_DOC: 'Technical information',
  DUPLICATE_FIELDS: 'Duplicate fields',
  GENERIC_REMOVE: 'Rmove',
  USER_EDIT: 'Edit user',
  USER_REMOVE: 'Remove user',
};

export default translations;
